import { FilterGroup } from 'components/Filters/components/FilterModal'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { FilterStore } from 'components/Filters/FilterStore'
import { useQuery } from '@tanstack/react-query'
import useApiService from 'services/api'

export function UserFilters({ store }: { store: FilterStore }) {
  const api = useApiService()
  const { data: userTypes } = useQuery({
    queryKey: ['user-types'],
    queryFn: () => api.getUserTypes(),
  })

  return (
    <FilterGroup title="Filters">
      <SelectFilter
        filterKey="user_type"
        title="User Type"
        options={userTypes ?? []}
        filterStore={store}
      />
      <SelectFilter
        filterKey="is_active"
        title="Status"
        options={[
          { value: 'true', label: 'Active' },
          { value: 'false', label: 'Inactive' },
        ]}
        filterStore={store}
      />
    </FilterGroup>
  )
}
